// CreateAdmin.tsx
import React, { useState } from "react";
import {
  Modal,
  TextInput,
  PasswordInput,
  Text,
  Button,
  Group,
} from "@mantine/core";
import { RowDataStaff } from "./types";
import classes from "./Staff.module.css";

interface CreateStaffProps {
  isVisible: boolean;
  onClose: () => void;
  onAddStaff: (NewStaff: RowDataStaff) => void;
}

const CreateStaff: React.FC<CreateStaffProps> = ({
  isVisible,
  onClose,
  onAddStaff,
}) => {
  const [NewStaff, setNewStaff] = useState<RowDataStaff>({
    staffId: "",
    name: "",
    phone_number: "",
    email: "",
    KPI: "",
    password: "",
    reenterPassword: "",
    action: "",
  });

  const [passwordsMatch, setPasswordsMatch] = useState(true);

  const handleAddStaff = () => {
    // Check if any field is empty
    if (
      !NewStaff.name ||
      !NewStaff.phone_number ||
      !NewStaff.email ||
      !NewStaff.password ||
      !NewStaff.reenterPassword
    ) {
      // Display a warning message (you can use a library or create a custom modal for this)
      alert("Please fill in all of the required details");
      return;
    }

    if( NewStaff.phone_number.trim().length < 9 || !/^\d*$/.test(NewStaff.phone_number.trim())){
        alert("Invalid phone number");
        return;
    }

    // Check if the passwords match
    const passwordsMatch = NewStaff.password === NewStaff.reenterPassword;

    if (!passwordsMatch) {
      alert("Passwords do not match");
      setPasswordsMatch(false);
      return;
    }

    // Validation passed, proceed with adding the customer
    onAddStaff({
      ...NewStaff,
      action: "Add",
    });

    setNewStaff({
      staffId: "",
      name: "",
      phone_number: "",
      email: "",
      KPI: "",
      password: "",
      reenterPassword: "",
      action: "",
    });

    onClose();
  };

  return (
    <Modal
      opened={isVisible}
      onClose={onClose}
      size="md"
      padding="lg"
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>New Staff</div>
      }
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleAddStaff();
        }}
      >
        <div className={classes.spacing}>
          <TextInput
            label="Name"
            placeholder="Enter staff full name (eg. John Doe)"
            maxLength={255}
            value={NewStaff.name}
            required
            onChange={(e) =>
              setNewStaff({ ...NewStaff, name: e.currentTarget.value })
            }
          />

          {/* <TextInput
          label="Role"
          value={NewStaff.role}
          required
          onChange={(e) => setNewStaff({ ...NewStaff, role: e.currentTarget.value })}
        /> */}

          <TextInput
            label="Phone Number"
            maxLength={10}
            leftSection={<Text fz={14} c='#2D2D2D' lh={'normal'}>+60</Text>}
            value={NewStaff.phone_number}
            required
            onChange={(e) =>
              setNewStaff({ ...NewStaff, phone_number: e.currentTarget.value })
            }
          />

          <TextInput
            label="Email"
            placeholder="name@example.com"
            maxLength={255}
            value={NewStaff.email}
            required
            onChange={(e) =>
              setNewStaff({ ...NewStaff, email: e.currentTarget.value })
            }
          />

          <PasswordInput
            value={NewStaff.password}
            maxLength={255}
            onChange={(e) =>
              setNewStaff({ ...NewStaff, password: e.currentTarget.value })
            }
            placeholder="Your password"
            label="Password"
            required
          />

          <PasswordInput
            value={NewStaff.reenterPassword}
            maxLength={255}
            onChange={(e) => {
              setNewStaff({
                ...NewStaff,
                reenterPassword: e.currentTarget.value,
              });
              setPasswordsMatch(NewStaff.password === e.currentTarget.value);
            }}
            placeholder="Reenter your password"
            label="Reenter Password"
            required
          />

          {!passwordsMatch && (
            <Text color="red" mt="sm">
              Passwords do not match
            </Text>
          )}
          <Group className={classes.buttonBottom}>
            <Button onClick={() => onClose()} className={classes.buttonCancel}>
              Back
            </Button>
            <Button type="submit" className={classes.buttonSaveChanges}>
              Submit
            </Button>
          </Group>
        </div>
      </form>
    </Modal>
  );
};

export default CreateStaff;
